import React from 'react';
import styled from 'styled-components';
import { BULK_UPLOAD_IMAGE_MAX_COUNT } from '../../shared/constants/limits';
import { getPageMessage } from '../../shared/constants/pageMessages';

interface DragDropLayerProps {
  dragState: 'list' | 'viewer' | null;
}

const DragDropLayer: React.FC<DragDropLayerProps> = ({ dragState }) => {
  if (dragState === null) return null;

  const dropTextKey = dragState === 'list' ? 'DRAG_DROP_CREATE_WORK' : 'DRAG_DROP_CREATE_DETAIL';

  return (
    <LayerContainer>
      <DropZone>
        <DropText>{getPageMessage(dropTextKey)}</DropText>
        <LimitText>{getPageMessage('DRAG_DROP_LIMIT_TEXT', { maxCount: BULK_UPLOAD_IMAGE_MAX_COUNT })}</LimitText>
      </DropZone>
    </LayerContainer>
  );
};

const LayerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: none;
`;

const DropZone = styled.div`
  border: 1px dashed ${({ theme }) => theme.colors.color_Gray_05};
  padding: 20px 36px;
  text-align: left;
  animation: pulse 1.5s ease-in-out infinite;
  
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.02);
    }
  }
`;

const DropText = styled.div`
  ${({ theme }) => theme.typography.Body_02_1};
  color: ${({ theme }) => theme.colors.color_Gray_03};
  margin-bottom: 6px;
`;

const LimitText = styled.div`
  ${({ theme }) => theme.typography.Body_03_1};
  color: ${({ theme }) => theme.colors.color_Gray_04};
`;

export default DragDropLayer;
